import { SelectOption } from './Helpers';

export const countries: SelectOption[] = [
	{ value: 'DK', label: 'Danmark' },
	{ value: 'NO', label: 'Norge' },
	{ value: 'SE', label: 'Sverige' },
];
